import { WappPanel } from '$comp/wapp-panel'
import { VisibilityHandler } from './components/visibility-handler'

export function Wapp() {
  return (
    <VisibilityHandler zIndex={1}>
      <WappPanel />
    </VisibilityHandler>
  )
}
